(()=>{"use strict";

const HOST_SELECTOR="shopify-chat#ShopifyChat,shopify-chat[id='ShopifyChat'],shopify-chat,inbox-online-store-chat#ShopifyChat,inbox-online-store-chat[id='ShopifyChat'],inbox-online-store-chat";
const LAUNCHER_SELECTORS=[
  ".chat-toggle",
  "button[data-spec=\"toggle-button\"]",
  "button[class*='chat-toggle' i]",
  "button[class*='chat_launcher' i]",
  "button[class*='chat-launcher' i]",
  "button[data-testid*='launcher' i]",
  "button[class*='launcher' i]",
  "button[aria-label*='sohbet' i]",
  "button[aria-label*='chat' i]"
];

const rootObservers=new WeakMap();
const getHost=()=>document.querySelector(HOST_SELECTOR);

function findLauncher(root){
  if(!root)return null;
  for(const selector of LAUNCHER_SELECTORS){
    const match=root.querySelector?.(selector);
    if(match)return match;
  }
  const nodes=root.querySelectorAll?.("*")||[];
  for(const node of nodes){
    if(!node.shadowRoot)continue;
    const nested=findLauncher(node.shadowRoot);
    if(nested)return nested;
  }
  return null;
}

function hideLauncher(launcher){
  if(!launcher)return false;
  if(launcher.style.getPropertyValue("display")!=="none"||launcher.style.getPropertyPriority("display")!=="important"){
    launcher.style.setProperty("display","none","important");
    launcher.style.setProperty("visibility","hidden","important");
    launcher.style.setProperty("opacity","0","important");
    launcher.style.setProperty("pointer-events","none","important");
    launcher.style.setProperty("width","0","important");
    launcher.style.setProperty("height","0","important");
    launcher.style.setProperty("min-width","0","important");
    launcher.style.setProperty("min-height","0","important");
    launcher.style.setProperty("padding","0","important");
    launcher.style.setProperty("margin","0","important");
    launcher.style.setProperty("border","0","important");
    launcher.style.setProperty("overflow","hidden","important");
  }
  if(launcher.getAttribute("aria-hidden")!=="true")launcher.setAttribute("aria-hidden","true");
  if(launcher.getAttribute("tabindex")!=="-1")launcher.setAttribute("tabindex","-1");
  launcher.dataset.ddtb1NativeHidden="1";
  return true;
}

function discoverShadowRoots(root){
  if(!root)return;
  const nodes=root.querySelectorAll?.("*")||[];
  for(const node of nodes){
    if(node.shadowRoot)observeRoot(node.shadowRoot);
  }
}

function observeRoot(root){
  if(!root||rootObservers.has(root))return;
  const observer=new MutationObserver(()=>{
    suppressNativeLauncher();
    discoverShadowRoots(root);
  });
  observer.observe(root,{childList:true,subtree:true,attributes:true,attributeFilter:["style","class"]});
  rootObservers.set(root,observer);
  discoverShadowRoots(root);
}

function suppressNativeLauncher(){
  const host=getHost();
  if(!host)return null;
  if(host.shadowRoot)observeRoot(host.shadowRoot);
  const launcher=findLauncher(host.shadowRoot);
  if(launcher)hideLauncher(launcher);
  return launcher;
}

let launcherProbeAttempts=0;
const probeLauncher=()=>{
  const launcher=suppressNativeLauncher();
  if(launcher||launcherProbeAttempts++>=40)return;
  setTimeout(probeLauncher,250);
};
probeLauncher();
let lateLauncherChecks=0;
const lateLauncherTimer=setInterval(()=>{
  const launcher=suppressNativeLauncher();
  lateLauncherChecks+=1;
  if(launcher||lateLauncherChecks>=4)clearInterval(lateLauncherTimer);
},5000);

const toggleInbox=()=>{
  let attempts=0;
  const run=()=>{
    const launcher=suppressNativeLauncher();
    if(launcher){
      launcher.click();
      setTimeout(suppressNativeLauncher,0);
      setTimeout(suppressNativeLauncher,250);
      return;
    }
    attempts+=1;
    if(attempts<60)setTimeout(run,100);
  };
  run();
};

/* Chat click handling is owned by dd-floating-tabbar-v1-core-base.js.
   Keep native launcher suppression here, but do not intercept the dock button. */

const ensureFloatingSearchStyle=()=>{
  if(document.getElementById("ddtb1-floating-search-style"))return;
  const style=document.createElement("style");
  style.id="ddtb1-floating-search-style";
  style.textContent=`
.ddtb1__floating-search{position:absolute;left:6px;right:6px;bottom:calc(100% + 10px);z-index:24;padding:5px;border:1px solid rgba(255,255,255,.8);border-radius:18px;background:rgba(246,249,245,.52);box-shadow:0 14px 36px rgba(25,31,24,.12),0 3px 10px rgba(25,31,24,.06),inset 0 1px 0 rgba(255,255,255,.92);backdrop-filter:blur(34px) saturate(1.5);-webkit-backdrop-filter:blur(34px) saturate(1.5);pointer-events:auto}
.ddtb1__floating-search[hidden]{display:none!important}
.ddtb1__floating-search-form{height:44px;display:flex;align-items:center;gap:8px;padding:0 6px 0 12px;border:1px solid rgba(255,255,255,.76);border-radius:14px;background:rgba(255,255,255,.48);box-shadow:inset 0 1px 0 rgba(255,255,255,.86)}
.ddtb1__floating-search-icon{flex:0 0 auto;width:19px;height:19px;display:grid;place-items:center;color:#5f625d}
.ddtb1__floating-search-icon svg{width:19px;height:19px;display:block;fill:none;stroke:currentColor;stroke-width:1.7;stroke-linecap:round;stroke-linejoin:round}
.ddtb1__floating-search-input{min-width:0;flex:1;height:100%;padding:0;border:0!important;outline:0!important;box-shadow:none!important;background:transparent!important;color:#171816;font:inherit;font-size:14px;line-height:1.2;letter-spacing:0}
.ddtb1__floating-search-input::-webkit-search-cancel-button{cursor:pointer}
.ddtb1__floating-search-input::placeholder{color:rgba(56,61,53,.56);opacity:1}
.ddtb1__floating-search-submit{appearance:none;flex:0 0 auto;width:34px;height:34px;margin:0;padding:0;border:1px solid rgba(255,255,255,.8);border-radius:11px;background:rgba(217,255,199,.72);color:#172016;display:grid;place-items:center;cursor:pointer;box-shadow:inset 0 1px 0 rgba(255,255,255,.9);transition:transform .2s ease,background-color .2s ease}
.ddtb1__floating-search-submit svg{width:17px;height:17px;display:block;fill:none;stroke:currentColor;stroke-width:1.8;stroke-linecap:round;stroke-linejoin:round}
.ddtb1__floating-search-submit:focus-visible,.ddtb1__floating-search-input:focus-visible{outline:none}
.ddtb1__floating-search-submit:focus-visible{box-shadow:0 0 0 2px rgba(217,255,199,.68),inset 0 1px 0 rgba(255,255,255,.9)}
.ddtb1.is-floating-search-open [data-ddtb1-search]{background:rgba(217,255,199,.32);color:#171816}
.ddtb1.is-floating-search-open [data-ddtb1-search] .ddtb1__dot{opacity:1;transform:translate(-50%,0) scale(1)}
.ddtb1__suggestions{margin:0 0 5px;padding:7px;border:1px solid rgba(255,255,255,.78);border-radius:15px;background:rgba(248,251,247,.68);box-shadow:0 10px 28px rgba(25,31,24,.09),inset 0 1px 0 rgba(255,255,255,.9);backdrop-filter:blur(30px) saturate(1.42);-webkit-backdrop-filter:blur(30px) saturate(1.42);max-height:min(250px,42vh);overflow:auto;overscroll-behavior:contain}
.ddtb1__suggestions[hidden]{display:none!important}
.ddtb1__suggestion-group+.ddtb1__suggestion-group{margin-top:7px;padding-top:7px;border-top:1px solid rgba(83,94,79,.1)}
.ddtb1__suggestion-title{margin:0 4px 5px;color:#6e756b;font-size:8.5px;line-height:1;text-transform:uppercase;letter-spacing:.13em;font-weight:750}
.ddtb1__suggestion-list{display:grid;gap:3px}
.ddtb1__suggestion-item{min-width:0;display:grid;grid-template-columns:38px minmax(0,1fr) auto;align-items:center;gap:8px;padding:5px;border-radius:10px;color:#1d221c;text-decoration:none;background:transparent;transition:background-color .16s ease,transform .16s ease}
.ddtb1__suggestion-item:hover,.ddtb1__suggestion-item:focus-visible{background:rgba(217,255,199,.48);outline:none;transform:translateY(-1px)}
.ddtb1__suggestion-thumb{width:38px;height:38px;border-radius:9px;overflow:hidden;display:grid;place-items:center;background:rgba(255,255,255,.58);border:1px solid rgba(96,104,91,.08);color:#697066;font-size:11px;font-weight:700}
.ddtb1__suggestion-thumb img{width:100%;height:100%;object-fit:cover;display:block}
.ddtb1__suggestion-copy{min-width:0}
.ddtb1__suggestion-name{display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:11.5px;line-height:1.2;font-weight:650;letter-spacing:-.01em}
.ddtb1__suggestion-meta{display:block;margin-top:2px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;color:#7a8177;font-size:9px;line-height:1.15}
.ddtb1__suggestion-arrow{width:24px;height:24px;border-radius:8px;display:grid;place-items:center;background:rgba(255,255,255,.52);color:#33402f;font-size:14px}
.ddtb1__suggestion-categories{display:flex;flex-wrap:wrap;gap:5px}
.ddtb1__suggestion-chip{display:inline-flex;align-items:center;min-height:28px;max-width:100%;padding:0 9px;border:1px solid rgba(255,255,255,.72);border-radius:999px;background:rgba(255,255,255,.46);color:#293027;text-decoration:none;font-size:10px;font-weight:650;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.ddtb1__suggestion-chip:hover,.ddtb1__suggestion-chip:focus-visible{background:rgba(217,255,199,.58);outline:none}
@media(hover:hover){.ddtb1__floating-search-submit:hover{background:rgba(217,255,199,.9);transform:scale(1.05)}}
@media(max-width:620px){.ddtb1__floating-search{left:4px;right:4px;bottom:calc(100% + 8px);padding:4px;border-radius:17px}.ddtb1__floating-search-form{height:43px;border-radius:13px}.ddtb1__floating-search-input{font-size:14px}}
@media(prefers-reduced-motion:reduce){.ddtb1__floating-search-submit{transition:none!important}}
`;
  document.head.appendChild(style);
};

const searchRoute=()=>{
  const root=window.Shopify?.routes?.root||"/";
  return `${root.replace(/\/?$/,"/")}search`;
};

const predictiveSearchRoute=()=>{
  const root=window.Shopify?.routes?.root||"/";
  return `${root.replace(/\/?$/,"/")}search/suggest.json`;
};

const suggestionLabels=()=>{
  const locale=String(document.documentElement.lang||"tr").toLowerCase().split("-")[0];
  const labels={
    tr:{products:"Ürünler",collections:"Kategoriler",product:"Ürün",collection:"Kategori"},
    en:{products:"Products",collections:"Categories",product:"Product",collection:"Category"},
    es:{products:"Productos",collections:"Categorías",product:"Producto",collection:"Categoría"},
    ru:{products:"Товары",collections:"Категории",product:"Товар",collection:"Категория"},
    ar:{products:"المنتجات",collections:"الفئات",product:"منتج",collection:"فئة"},
    de:{products:"Produkte",collections:"Kategorien",product:"Produkt",collection:"Kategorie"},
    fr:{products:"Produits",collections:"Catégories",product:"Produit",collection:"Catégorie"}
  };
  return labels[locale]||labels.tr;
};

const getSuggestionImage=item=>{
  const image=item?.featured_image||item?.image;
  if(typeof image==="string")return image;
  return image?.url||image?.src||"";
};

const makeSuggestionThumb=(item,fallback)=>{
  const thumb=document.createElement("span");
  thumb.className="ddtb1__suggestion-thumb";
  const src=getSuggestionImage(item);
  if(src){
    const img=document.createElement("img");
    img.src=src;
    img.alt=item?.title||"";
    img.loading="lazy";
    thumb.appendChild(img);
  }else{
    thumb.textContent=String(item?.title||fallback||"").trim().slice(0,1).toUpperCase();
  }
  return thumb;
};

const renderSuggestions=(root,data)=>{
  const panel=root?.querySelector("[data-ddtb1-floating-search]");
  const box=panel?.querySelector("[data-ddtb1-suggestions]");
  if(!box)return;
  const results=data?.resources?.results||{};
  const products=(results.products||[]).slice(0,4);
  const collections=(results.collections||[]).slice(0,4);
  const labels=suggestionLabels();
  box.replaceChildren();

  if(products.length){
    const group=document.createElement("section");
    group.className="ddtb1__suggestion-group";
    const title=document.createElement("p");
    title.className="ddtb1__suggestion-title";
    title.textContent=labels.products;
    const list=document.createElement("div");
    list.className="ddtb1__suggestion-list";
    products.forEach(item=>{
      const link=document.createElement("a");
      link.className="ddtb1__suggestion-item";
      link.href=item.url||searchRoute();
      link.appendChild(makeSuggestionThumb(item,labels.product));

      const copy=document.createElement("span");
      copy.className="ddtb1__suggestion-copy";
      const name=document.createElement("span");
      name.className="ddtb1__suggestion-name";
      name.textContent=item.title||"";
      const meta=document.createElement("span");
      meta.className="ddtb1__suggestion-meta";
      meta.textContent=item.vendor||item.type||item.product_type||labels.product;
      copy.append(name,meta);

      const arrow=document.createElement("span");
      arrow.className="ddtb1__suggestion-arrow";
      arrow.setAttribute("aria-hidden","true");
      arrow.textContent="→";

      link.append(copy,arrow);
      list.appendChild(link);
    });
    group.append(title,list);
    box.appendChild(group);
  }

  if(collections.length){
    const group=document.createElement("section");
    group.className="ddtb1__suggestion-group";
    const title=document.createElement("p");
    title.className="ddtb1__suggestion-title";
    title.textContent=labels.collections;
    const list=document.createElement("div");
    list.className="ddtb1__suggestion-categories";
    collections.forEach(item=>{
      const link=document.createElement("a");
      link.className="ddtb1__suggestion-chip";
      link.href=item.url||searchRoute();
      link.textContent=item.title||labels.collection;
      list.appendChild(link);
    });
    group.append(title,list);
    box.appendChild(group);
  }

  box.hidden=!(products.length||collections.length);
};

const clearSuggestions=root=>{
  const box=root?.querySelector("[data-ddtb1-suggestions]");
  if(!box)return;
  box.hidden=true;
  box.replaceChildren();
};

const bindFloatingPredictiveSearch=(root,input)=>{
  if(!root||!input||input.dataset.ddtb1PredictiveReady==="1")return;
  input.dataset.ddtb1PredictiveReady="1";
  let timer=0;
  let controller=null;

  const run=()=>{
    const term=input.value.trim();
    if(term.length<2){
      controller?.abort();
      clearSuggestions(root);
      return;
    }
    controller?.abort();
    controller=new AbortController();
    const params=new URLSearchParams();
    params.set("q",term);
    params.set("resources[type]","product,collection");
    params.set("resources[limit]","6");
    params.set("resources[limit_scope]","each");
    params.set("resources[options][unavailable_products]","hide");
    fetch(`${predictiveSearchRoute()}?${params.toString()}`,{signal:controller.signal,headers:{"Accept":"application/json"}})
      .then(response=>{
        if(!response.ok)throw new Error(String(response.status));
        return response.json();
      })
      .then(data=>renderSuggestions(root,data))
      .catch(error=>{
        if(error?.name==="AbortError")return;
        clearSuggestions(root);
      });
  };

  input.addEventListener("input",()=>{
    window.clearTimeout(timer);
    timer=window.setTimeout(run,140);
  });
  input.addEventListener("search",run);
  if(input.value.trim().length>=2)run();
};

const ensureFloatingSearch=root=>{
  if(!root)return null;
  let panel=root.querySelector("[data-ddtb1-floating-search]");
  if(panel)return panel;
  const shell=root.querySelector(".ddtb1__shell");
  const trigger=root.querySelector("[data-ddtb1-search]");
  if(!shell||!trigger)return null;
  ensureFloatingSearchStyle();

  const label=trigger.getAttribute("aria-label")||"Ara";
  panel=document.createElement("div");
  panel.className="ddtb1__floating-search";
  panel.dataset.ddtb1FloatingSearch="";
  panel.hidden=true;
  panel.setAttribute("aria-hidden","true");

  const suggestions=document.createElement("div");
  suggestions.className="ddtb1__suggestions";
  suggestions.dataset.ddtb1Suggestions="";
  suggestions.hidden=true;
  suggestions.setAttribute("aria-live","polite");

  const form=document.createElement("form");
  form.className="ddtb1__floating-search-form";
  form.action=searchRoute();
  form.method="get";
  form.setAttribute("role","search");

  const icon=document.createElement("span");
  icon.className="ddtb1__floating-search-icon";
  icon.setAttribute("aria-hidden","true");
  icon.innerHTML='<svg viewBox="0 0 24 24"><circle cx="10.8" cy="10.8" r="6.9"/><path d="m16 16 4.4 4.4"/></svg>';

  const input=document.createElement("input");
  input.className="ddtb1__floating-search-input";
  input.dataset.ddtb1FloatingSearchInput="";
  input.type="search";
  input.name="q";
  input.placeholder=label;
  input.setAttribute("aria-label",label);
  input.autocomplete="off";
  input.autocapitalize="off";
  input.spellcheck=false;
  input.enterKeyHint="search";
  if(location.pathname.includes("/search"))input.value=new URLSearchParams(location.search).get("q")||"";

  const prefix=document.createElement("input");
  prefix.type="hidden";
  prefix.name="options[prefix]";
  prefix.value="last";

  const submit=document.createElement("button");
  submit.className="ddtb1__floating-search-submit";
  submit.type="submit";
  submit.setAttribute("aria-label",label);
  submit.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h13"/><path d="m14 7 5 5-5 5"/></svg>';

  form.append(icon,input,prefix,submit);
  panel.append(suggestions,form);
  shell.prepend(panel);
  bindFloatingPredictiveSearch(root,input);
  trigger.setAttribute("aria-haspopup","true");
  trigger.setAttribute("aria-expanded","false");
  return panel;
};

const setFloatingSearch=(root,open,{focus=true}={})=>{
  const panel=ensureFloatingSearch(root);
  const trigger=root?.querySelector("[data-ddtb1-search]");
  if(!panel||!trigger)return;
  const next=Boolean(open);
  panel.hidden=!next;
  panel.setAttribute("aria-hidden",next?"false":"true");
  if(!next)clearSuggestions(root);
  root.classList.toggle("is-floating-search-open",next);
  trigger.setAttribute("aria-expanded",next?"true":"false");
  const anySearchOpen=Boolean(document.querySelector("[data-ddtb1].is-floating-search-open"));
  document.body.classList.toggle("ddtb1-search-open",anySearchOpen);
  if(next&&focus){
    requestAnimationFrame(()=>{
      const input=panel.querySelector("[data-ddtb1-floating-search-input]");
      input?.focus({preventScroll:true});
      if(input?.value)input.setSelectionRange(input.value.length,input.value.length);
    });
  }
};

const floatingSearchOpen=root=>Boolean(root?.classList.contains("is-floating-search-open"));

document.addEventListener("click",event=>{
  const target=event.target instanceof Element ? event.target : event.target?.parentElement;
  if(!target)return;
  const trigger=target.closest?.("[data-ddtb1-search]");
  if(trigger){
    const root=trigger.closest("[data-ddtb1]");
    if(!root)return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if(root.classList.contains("is-quick-open"))root.querySelector("[data-ddtb1-hub]")?.click();
    setFloatingSearch(root,!floatingSearchOpen(root));
    return;
  }

  document.querySelectorAll("[data-ddtb1].is-floating-search-open").forEach(root=>{
    const panel=root.querySelector("[data-ddtb1-floating-search]");
    if(panel?.contains(target))return;
    setFloatingSearch(root,false,{focus:false});
  });
},true);

document.addEventListener("keydown",event=>{
  if(event.key!=="Escape")return;
  document.querySelectorAll("[data-ddtb1].is-floating-search-open").forEach(root=>{
    const trigger=root.querySelector("[data-ddtb1-search]");
    setFloatingSearch(root,false,{focus:false});
    trigger?.focus({preventScroll:true});
  });
});

const current=document.currentScript||[...document.scripts].find(script=>script.src.includes("dd-floating-tabbar-v1.js"));
const src=current?.src||"";
if(!src)return;
const coreSrc=src.replace(/dd-floating-tabbar-v1\.js(?=([?#]|$))/,"dd-floating-tabbar-v1-core.js");
if(!coreSrc||coreSrc===src)return;
const core=document.createElement("script");
core.src=coreSrc;
core.async=false;
document.head.appendChild(core);
})();
